import { Stack, Typography } from "@mui/material"
import CustomButton from "components/CustomButton";
import CustomDialog from "components/CustomDialog"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import useMc from "hooks/useMc";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import http from "../../../http";
import { apiUrl } from "config/settings";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import { MC_ST_LOCATION } from "config/const";
import { setMcList } from "store/mcSlice";
import useDataManager from "hooks/useDataManager";
import NullCheck from "components/NullCheck";

const Item = ({ title, value, button, valueColor }) => {
    const dispatch = useDispatch()
    return (
        <Stack direction="row" alignItems="center">
            <Typography fontWeight={600} fontSize={14}>{title}</Typography>:

            <Stack direction="row">
                <CustomButton
                    title={value}
                    textColor={valueColor}
                    variant="text"
                    onClick={() => {
                        navigator.clipboard.writeText(value);
                        dispatch(setShowMassage({ massage: "TEXT_COPY_SUCCESSFULLY" }));
                    }}
                />

                <NullCheck valueForCheck={button?.title}>
                    <CustomButton
                        title={button?.title}
                        variant="text"
                        textColor={button?.textColor}
                        onClick={() => button?.onClick ? button?.onClick() : null}
                    />
                </NullCheck>
            </Stack>

        </Stack >
    )

}

const McInfo = ({ mcGuid, setMcGuid, list }) => {
    const dispatch = useDispatch()
    const { editItem } = useDataManager()
    const navigate = useNavigate();
    const { checkConnected } = useMc()
    const { bt } = useBizTypeTranslation();
    const [item, setItem] = useState(null)

    useEffect(() => {
        if (mcGuid)
            setItem(list?.find(m => m?.guid === mcGuid))
    }, [mcGuid, list]);

    const moveAdminMc = (guid) => {
        navigate(`/Micro-Controllers-Manager/${guid}`)
    }

    const moveManagerMc = (guid) => {
        navigate(`/Micro-Controllers/${guid}`)
    }

    const finishInstallation = (mc) => {
        dispatch(setShowLoading(true))
        http.patch(`${apiUrl}/mc/installComplete/${mc?.guid}`)
            .then(res => {
                dispatch(setShowLoading(false))

                if (res?.data?.id === 1) {
                    const newList = editItem({ ...mc, stLocation: MC_ST_LOCATION.CUSTOMER }, list);
                    dispatch(setMcList(newList))
                    dispatch(setShowMassage({ massage: res?.data?.message, type: "success" }));

                }
                else {
                    dispatch(setShowMassage({ massage: "ERROR", type: "error" }));
                }
            })
            .catch(error => {
                dispatch(setShowLoading(false))
                dispatch(setShowMassage({ massage: "ERROR", type: "error" }));
            })
    }

    if (!item) return;

    return (
        <CustomDialog
            open={item ? true : false}
            onClose={() => setMcGuid(null)}
            title={item?.name}
            closeBtn='CLOSE'
            minWidth={350}
        >
            <Stack spacing={2}>
                <Stack >

                    <Item title={bt("GUID")} value={item?.guid} />
                    <Item title={bt("NAME")} value={item?.name} />
                    <Item title={bt("AREA")} value={item?.area?.name} />

                    <Item
                        title={bt("ST_LOCATION")}
                        value={bt(item?.stLocation)}
                        button={item?.stLocation === MC_ST_LOCATION.INSTALLATION
                            ? { title: `(${bt("FINISH_INSTALLATION")})`, textColor: "error.text", onClick: () => finishInstallation(item) }
                            : null
                        }
                    />

                    <Item title={bt("DEVICE_TYPE")} value={bt(item?.deviceType)} />
                    <Item title={bt("SOFTWARE_TYPE")} value={item?.softwareType} />
                    <Item title={bt("SOFTWARE_VERSION")} value={item?.softwareVersion} />
                    <Item title={bt("SIM_ID")} value={item?.simCCID} />
                    <Item title={bt("MODEM_IMEI")} value={item?.modemIMEI} />

                    <Item
                        title={bt("MC_CONNECTED_STATUS")}
                        valueColor={item?.isConnected ? "success.main" : "error.text"}
                        value={bt(item?.isConnected ? "CONNECTED" : "DISCONNECTED")}
                    />
                </Stack>

                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={2}
                    useFlexGap
                    sx={{ flexWrap: 'wrap' }}
                >
                    <CustomButton
                        title="CHECK_CONNECTED"
                        onClick={() => checkConnected(item?.guid)}
                        disabled={item?.isConnected}
                    />

                    <CustomButton
                        title="MOVE_TO_ADMIN_MC"
                        onClick={() => moveAdminMc(item?.guid)}
                    />
                    <CustomButton
                        title="MOVE_TO_MANAGER_MC"
                        onClick={() => moveManagerMc(item?.guid)}
                    />
                </Stack>
            </Stack>
        </CustomDialog>
    )
}
export default McInfo